import { CareTeamMember } from '../../type';
import { useChannel } from './useChannelHooks';
import { useCareTeamSelector } from './useCareTeamSelector';
import { useCallback } from 'react';

export const useCareTeamMembers = (channelGuid: string): CareTeamMember[] => {
  const channel = useChannel(channelGuid);
  return useCareTeamSelector(
    useCallback(
      (state) => {
        if (channel?.type === 'PEER_TO_PEER') {
          return [];
        }
        const patientGuid = channel?.attributes.patientGuid;
        const providerSfId = channel?.attributes.providerSfId;
        if (state === 'LOADING' || !patientGuid) {
          return [];
        }
        const careTeamMembers =
          state.patientCareTeamMembers?.[patientGuid] ?? [];
        return careTeamMembers.filter(
          (member) => member.providerSfId === providerSfId,
        );
      },
      [channel],
    ),
  );
};
